<div class="user-info-card" *ngIf="value">
    <shared-chat-avatar class="header-avatar" [participant]="userAvatar" [isGroup]="false">
    </shared-chat-avatar>
    <div class="resta">
        <div class="key title">{{value.userKey}} - {{value.fullName}}</div>
        <div class="company">{{value.organitzationName}}</div>
        <div class="email">{{value.eMail}}</div>
        <div class="phone">{{value.prefix}} {{value.phone}}</div>
    </div>
</div>